@if (errorMessage) {
  <tidy-error-message [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container">
      <tidy-text [header]="'Happiness'" />
      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <form [formGroup]="form" novalidate action="#">
        <tidy-header-select
          [items]="addressFilter"
          [form]="form.get('selectedAddress')"
          formControlName="selectedAddress"
          (optionChange)="onFilterValueChange()"
          [icon]="'assets/svg/home.svg'" />
      </form>
      <tidy-small-button
        [text]="'Add Offering'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToAddItemPage()" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'happiness'" />
    </div>
  </tidy-desktop-header>
}

@if (!windowService.isDesktopRes) {
  @if (isDataLoaded) {
    <div style="margin-bottom: 10px;">
      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
    </div>
    <div class="custom-desktop-header" style="margin-bottom: 10px;">
      <form [formGroup]="form" novalidate action="#" class="form-filters">
        <tidy-header-select
          [items]="addressFilter"
          [form]="form.get('selectedAddress')"
          formControlName="selectedAddress"
          (optionChange)="onFilterValueChange()"
          [icon]="'assets/svg/home.svg'" />
      </form>
    </div>
    <div style="margin-bottom: 10px;">
      <tidy-small-button
        [text]="'Add Offering'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToAddItemPage()" />
    </div>
  } @else {
    <!-- Same three control rows as above, as grey pills with matching
         heights, so the real controls swap in without anything shifting. -->
    <div style="margin-bottom: 10px;">
      <ion-skeleton-text [animated]="true" class="sk-control sk-control-search" />
    </div>
    <div class="custom-desktop-header" style="margin-bottom: 10px;">
      <ion-skeleton-text [animated]="true" class="sk-control sk-control-filter" />
    </div>
    <div style="margin-bottom: 10px;">
      <ion-skeleton-text [animated]="true" class="sk-control sk-control-button" />
    </div>
  }
}

<!-- First-load skeleton: mirrors the loaded layout (table on desktop, card
     grid on mobile) and floats in staggered; the real content then replaces
     it in place instantly, so the skeleton reads as becoming the page. -->
@if (!isDataLoaded) {
  @if (windowService.isDesktopRes) {
    <tidy-table
      [skeletonLoading]="true"
      [columnslabels]="headers" />
  } @else {
    <div class="happiness-grid">
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <tidy-happiness-card [skeleton]="true" />
      }
    </div>
  }
}

@if (isDataLoaded && items.length) {
  @if (windowService.isDesktopRes) {
    <tidy-table
      [dataSource]="rows"
      [displayedColumns]="headers"
      [columnslabels]="headers"
      [showColumnLines]="false"
      [rowsToShow]="50"
      [allRowIsClickable]="true"
      [skipEntrance]="true"
      (sortChange)="sortChanged($event)"
      (cellClick)="onTableColumnClick($event)"
      (toggleChange)="onTableToggleChange($event)"
      [infiniteScroll]="true"
      [totalRows]="rows.length" />
  } @else {
    <div class="happiness-grid">
      @for (item of items; track item.id) {
        <tidy-happiness-card
          [item]="item"
          (edit)="onEditItem($event)"
          (flagChange)="onFlagChange($event)" />
      }
    </div>
  }
}

@if (isDataLoaded && items.length === 0 && rawItems.length > 0) {
  <tidy-alert>
    <tidy-row>
      <tidy-text [body]="'No offerings match your search.'" />
    </tidy-row>
  </tidy-alert>
}

@if (isDataLoaded && rawItems.length === 0) {
  <tidy-alert>
    <tidy-row>
      <tidy-text [body]="'No offerings configured. Add offerings to track which can be upsold and which can be comped.'" />
    </tidy-row>
  </tidy-alert>
}
